export const ACCEPT_REQUEST_STATUS = 124;
export const GRANTED_REQUEST_STATUS = 125;
export const GRANTED_MOVED_DATE_REQUEST_STATUS = 126;
export const CANCELLED_DATE_REQUEST_STATUS = 127;

export default {
  ACCEPT_REQUEST_STATUS,
  GRANTED_REQUEST_STATUS,
  GRANTED_MOVED_DATE_REQUEST_STATUS,
  CANCELLED_DATE_REQUEST_STATUS,
};
